import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { Text } from '@websolutespa/bom-mixer-llm';
import style from './form-recap-error.module.scss';

export const FormRecapError: React.FC = () => {
  const label = useLabel();

  return (
    <div className={getClassNames(style.formRecapError, 'llm__row')}>
      <div className="llm__col --sm-10 --md-8 --lg-6">
        <Text body={label('llm.formRecapError')} />
      </div>
    </div>
  );
};
